export const TASK_PRIORITIES = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
} as const;

export const TASK_STATUSES = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  COMPLETED: 'completed',
  OVERDUE: 'overdue',
} as const;

export const VARIANT_TYPES = {
  TODAY: 'today',
  TOMORROW: 'tomorrow',
  ACTIVITY: 'activity',
} as const;

export type TaskPriority = typeof TASK_PRIORITIES[keyof typeof TASK_PRIORITIES];
export type TaskStatus = typeof TASK_STATUSES[keyof typeof TASK_STATUSES];
export type TaskManagerVariant = typeof VARIANT_TYPES[keyof typeof VARIANT_TYPES];

export interface Task {
  id: string;
  patient: string;
  type: string;
  provider: string;
  priority: TaskPriority;
  status: TaskStatus;
  time: string;
  avatar?: string;
}

export interface TaskItemProps {
  task: Task;
  onTaskClick?: (task: Task) => void;
  onActionClick?: (task: Task) => void;
  className?: string;
}

export interface TaskListProps {
  title: string;
  subtitle?: string;
  tasks: Task[];
  showMore?: boolean;
  onShowMore?: () => void;
  onTaskClick?: (task: Task) => void;
  onActionClick?: (task: Task) => void;
  className?: string;
}

export interface ReportData {
  title?: string;
  completed?: number;
  total?: number;
  percentage?: number;
  subtitle?: string;
  description?: string;
}

export interface TaskManagerCardProps {
  variant?: TaskManagerVariant;
  reportData?: ReportData;
  tasks?: Task[];
  showReportCard?: boolean;
  showMore?: boolean;
  onTaskClick?: (task: Task) => void;
  onActionClick?: (task: Task) => void;
  onShowMore?: () => void;
  className?: string;
}
